import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M3.05 7.837c-.06.06-.12.13-.18.19a.55.55 0 0 1 .07-.09Zm10.08-5.25a3.434 3.434 0 0 0-4.84 0l-5.24 5.25c-.06.06-.12.13-.18.19-.01.01-.02.02-.02.03a4.017 4.017 0 0 0 .2 5.47.725.725 0 0 0 .53.22.742.742 0 0 0 .53-.22.754.754 0 0 0 0-1.06 2.517 2.517 0 0 1 0-3.57.265.265 0 0 0 .05-.06l5.19-5.19a1.923 1.923 0 1 1 2.72 2.72l-4.4 4.4a.585.585 0 0 1-.83 0 .573.573 0 0 1 0-.82l3.11-3.12a.75.75 0 0 0-1.06-1.06l-3.11 3.12a2.082 2.082 0 0 0 2.95 2.94l4.4-4.4a3.434 3.434 0 0 0 0-4.84Z';
const draw24px = 'M19.33,11.35,12.6,18.08a2.79,2.79,0,0,1-3.95,0,2.74,2.74,0,0,1-.82-2,2.78,2.78,0,0,1,.82-2l4.76-4.75a.74.74,0,0,1,1.06,0,.75.75,0,0,1,0,1.06L9.71,15.2a1.28,1.28,0,0,0-.38.91,1.3,1.3,0,0,0,2.21.91l6.73-6.73a3.33,3.33,0,0,0,0-4.72,3.41,3.41,0,0,0-4.71,0l-8,8a4.27,4.27,0,0,0,0,6,.75.75,0,0,1,0,1.06.75.75,0,0,1-1.06,0,5.75,5.75,0,0,1-.27-7.86h0a3.45,3.45,0,0,1,.26-.28l8-8a4.83,4.83,0,0,1,6.83,6.84Zm-15,1.34-.1.12a3.45,3.45,0,0,1,.26-.28Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const PaperclipIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'paperclip'));
PaperclipIcon.displayName = 'PaperclipIcon';
PaperclipIcon.propTypes = Icon.propTypes;
PaperclipIcon.renderIcon = props => /*#__PURE__*/React.createElement(PaperclipIcon, props);
export default PaperclipIcon;
//# sourceMappingURL=PaperclipIcon.js.map